import {getStore} from './store'
import {createSelectorCreator, defaultMemoize} from 'reselect'
import _ from 'underscore'

export function subscribeToStore(handler) {
    const _handler = () => handler(getStore().getState())
    getStore().subscribe(_handler)
    _handler()
}

export function connect(mapState = null, mapDispatch = () => ({})) {
    return function(ContainerClass) {
        function ConnectedContainerClass(args) {
            ContainerClass.call(this, {
                ...args,
                ...mapDispatch(getStore().dispatch)
            })

            if (mapState !== null) {
                subscribeToStore(() => {
                    this.setState(mapState(getStore().getState()))
                })
            }
        }

        ConnectedContainerClass.prototype = Object.create(ContainerClass.prototype)
        ConnectedContainerClass.prototype.constructor = ConnectedContainerClass
        ConnectedContainerClass.prototype.init = function() {
            ContainerClass.prototype.init.apply(this, arguments)
            this.callStateChangeHandlersWithCurrentState()
            return this
        }

        return ConnectedContainerClass
    }
}

/**
 * Creates simple object for dispatch to redux.
 * Simple version of operation performed with `redux-actions`: createAction(type)(data)
 * @param type dispatched type
 * @param [payload] action payload for reducers
 * @returns {{type: *, payload: *}}
 */
export function createActionObject(type, payload) {
    return {
        type,
        payload
    }
}

/**
 * !Attention
 * Use only for bind redux with old code.
 * @param selector - function that should take store as first argument and returns selected object
 */
export function unsafe_selectWithState(selector = (state) => {}) {
    return selector(getStore().getState())
}

/**
 * !Attention
 * !TODO May be the method is candidate for regular usage (https://github.com/Actimind-Development/actitime/issues/941)
 * Use only for bind redux actions in old code or if not impossible use `connect` method
 * @param actionsMapper function that calls with dispatch and return bind actions
 * @returns {*}
 */
export function unsafe_bindActions(actionsMapper) {
    return actionsMapper(getStore().dispatch)
}

/**
 * Create deep equals selector using underscore _.isEqual instead of ===
 */
export const createDeepEqualSelector = createSelectorCreator(
    defaultMemoize,
    _.isEqual
)


// WEBPACK FOOTER //
// ./web/js/redux/utils.js